import React from "react";
import PageError from "./PageError";
import uiUtils from "./uiUtils";

const PageErrors = (props) => {
  const { errors, uiSchema_lookup, page_number } = props;
  let page_errors = {};
  let error_count = 0;

  // remove errors that aren't on the current page
  Object.keys(errors).map((machine_name) => {
    let lookup = uiSchema_lookup[machine_name];
    if (lookup !== undefined) {
      if (lookup[0] === page_number) {
        page_errors[machine_name] = errors[machine_name];
      }
    }
    return page_errors;
  });

  let flag = true;
  error_count = Object.keys(page_errors).length;
  if (error_count > 0) {
    Object.keys(page_errors).map((machine_name) => {
      if (
        machine_name === "agBusinesses" ||
        machine_name === "eta_790a_addendum_b_employment" ||
        machine_name === "eta_790a_addendum_b_housing"
      ) {
        for (let j = 0; j < page_errors[machine_name].length; j++) {
          if (
            !page_errors[machine_name][j] ||
            Object.keys(page_errors[machine_name][j]).length === 0
          ) {
            flag = false;
          } else {
            flag = true;
          }
        }
      }
      return "";
    });
  }
  if (error_count > 0 && flag) {
    return (
      <PageError>
        <div>
          <strong>
            There {uiUtils.isOrAre(error_count)} {error_count} field level{" "}
            {uiUtils.pluralS(error_count, "error")} on this page
          </strong>
          {Object.keys(page_errors).map((machine_name) => {
            let lookup = uiSchema_lookup[machine_name];
            let code = lookup[1];
            let message = page_errors[machine_name];
            // renderErrorMessage handles field and fieldArray types
            return uiUtils.renderErrorMessage(code, message);
          })}
        </div>
      </PageError>
    );
  } else {
    return "";
  }
};

export default PageErrors;
